<template>
  <div class="account-card">
    <div v-for="(item, index) in list" :key="item.code" class="c-content">
      <div class="c-lf">
        <div class="img-box">
          <img class="img-bg" :src="item.coverImg || defaultImg" alt="img" />
          <img
            v-if="isFrom === 'Favourites'"
            @click="clickImg(item, 'collect', index)"
            class="img-like"
            src="~img/favourite-full.svg"
            alt="icon-like"
          />
        </div>
      </div>
      <div class="c-rg" @click="clickImg(item, 'detail', index)">
        <div class="text-box">
          <p>{{ item.name }}</p>
          <p>{{ item.airportName }}</p>
          <p>{{ isFrom === 'Favourites' ? `${item.terminal}, ${item.inspection}` : '' }}</p>
          <p>{{ item.businessHours }}</p>
        </div>
        <div class="more-box">
          <img src="~img/member/icon-more.svg" alt="icon-more" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const png = require('../../assets/images/defaultLounge.png');
  export default {
    name: 'index',
    data() {
      return {
        defaultImg: png,
      };
    },
    props: {
      list: {
        type: Array,
        default: () => [],
      },
      isFrom: {
        type: String,
        default: 'Favourites',
      },
    },
    methods: {
      clickImg(item, type, index) {
        const data = {
          item: {
            ...item,
            image: item.coverImg || this.defaultImg,
          },
          type: type ? type : '',
          index,
        };
        this.$emit('clickView', data);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
